<template>
	<div class="group-mute">
		<MuteModal
			v-if="showMuteModal"
			:group="true"
			@close="showMuteModal = false"
		/>

		<GroupMutedIcon class="group-muted-icon" />

		<div class="title">{{ title }}</div>

		<div class="you-have">{{ youHave }}</div>
		<div class="until-time" @click="showMuteModal = true">
			{{ scheduled_time }}
		</div>

		<button class="unmute" @click="unmute()">
			<SpinnerOverlay
				v-show="spinner"
				class="spinner"
				cBackground="unset"
				sWidth="30px"
				sHeight="30px"
				cTop="5px"
				sColor="#ffffff"
			/>
			<span v-if="!spinner">{{ unmuteButton }}</span>
		</button>

		<div class="note">{{ $t('settings_notification_group_unmute_tip') }}</div>
	</div>
</template>

<script>
import store, {
	getMyMembershipForBubble,
	getCurrentChat,
	setMembership,
} from '@/store'
import MuteModal from './MuteModal'
import SpinnerOverlay from '@/components/SpinnerOverlay'
import { GroupMutedIcon } from '@/icons'
import moment from 'moment'
import { post } from '@/helpers/api'

export default {
	props: ['bubble_id'],
	components: { GroupMutedIcon, MuteModal, SpinnerOverlay },

	data() {
		return {
			store,
			showMuteModal: false,
			spinner: false,
		}
	},

	computed: {
		scheduled_time() {
			const membership = getMyMembershipForBubble(
				this.bubble_id || store.currentChatId
			)

			if (!membership.muteuntil)
				return this.$t('groupsettings_notifications_mute_title_indefinite')

			const midnightTonight = moment().endOf('day')
			const muteMoment = moment(membership.muteuntil + 'Z')

			if (muteMoment.diff(midnightTonight, 'days') > 1) {
				return this.$t('groupsettings_notifications_mute_title_indefinite')
			}
			if (muteMoment.isAfter(midnightTonight)) {
				return `${this.$t('common_tomorrow')}, ${muteMoment.format('LT')}`
			}
			return muteMoment.format('LT')
		},

		title() {
			return getCurrentChat().isdm
				? this.$t('settings_notification_dm_muted_title')
				: this.$t('settings_notification_group_muted_title')
		},

		youHave() {
			return getCurrentChat().isdm
				? this.$t('settings_notification_dm_muted_desc')
				: this.$t('settings_notification_group_muted_desc')
		},

		unmuteButton() {
			return getCurrentChat().isdm
				? this.$t('settings_notification_group_unmute_button')
				: this.$t('settings_notification_group_unmute_group')
		},
	},

	methods: {
		unmute() {
			const payload = {
				bubble_id: this.bubble_id ? this.bubble_id : store.currentChatId,
				mute: false,
				muteuntil: null,
			}

			this.spinner = true

			post('/api/v1/membership.update', payload)
				.then(({ membership }) => {
					this.spinner = false
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.group-mute {
	text-align: center;
	color: #4f5053;
}

.group-muted-icon {
	height: 40px;
	width: 50px;
	margin-top: 43px;
}

.title {
	font-family: Avenir-Heavy;
	font-size: 26px;
	margin-top: 16px;
	margin-bottom: 22px;
}

.you-have,
.until-time {
	font-family: Avenir-Medium;
	font-size: 18px;
}

.until-time {
	color: var(--blue-300);
	cursor: pointer;
}

.unmute {
	width: 146px;
	height: 40px;
	font-family: Avenir-Heavy;
	font-size: 14px;
	margin-top: 36px;
	margin-bottom: 36px;
	padding: 10px 24px;
	border-radius: 20px;
	background-color: var(--blue-300);
	color: #ffffff;
	position: relative;
}

.note {
	font-family: Avenir;
	font-size: 16px;
	color: $neutral-500;
}
</style>
